import groupRenderers from "./render/group/index"
import connectionRenderers from "./render/connection/index"


const uuidv1 = require('uuid/v1');

class MainRender {
    constructor(dom, groups = [], links = [], config = {}) {
        this.dom =dom;
        this.el = Snap(dom).g();
        
        this.el.addClass("tflow-unselectable");
        this.groups = [];
        this.links = [];
        this.startx = null; //拖曳开始时的坐标x
        this.starty = null; //拖曳开始时的坐标y
        this.status = 0; //状态：0 连接点画线；1.表格拖曳
        this.lineStartx = null;//线开始时的坐标x——圆心
        this.lineStarty = null;//线开始时的坐标y——圆心
        this.lineEndx = null; //线结束时的坐标x——当前鼠标位置 或者 结束点圆心
        this.lineEndy = null; // 线结束时的坐标y——当前鼠标位置 或者 结束点圆心
        this.tempLink = null;
        this.tempLinkEnt = null;
        this.config = this._mergeConfig(config)
        
        this.groupRenderers = groupRenderers[this.config.groupRender] || groupRenderers["default"]

        this.connectionRenderers = connectionRenderers[this.config.groupRender] || connectionRenderers["default"]

        this.groupDoms=[];
        this.linkDoms=[];
        
        this._init(groups,links)
        this._initEvent();
    }
    _init(groups,links){
        groups = groups || [];
        links = links || [];
        
        if(this.groupRenderers.init) this.groupRenderers.init(this)
        if(this.connectionRenderers.init) this.connectionRenderers.init(this)
        groups.forEach(this.addGroup,this)
        links.forEach(this.addLink,this)
        
        
    }
    _initEvent(){
        if(this.config.zoom){
            require("./utils/svg-pan-zoom") 
            var panZoomSVG = svgPanZoom(this.dom,{fit:false, zoomScaleSensitivity: 0.5});
        }
        
    }
    getGroupsData(){
        return this.groups
    }
    getLinksData(){
        return this.links
    }
    addGroup(group) {
        let groupDom = this._drawGroup(group);
        
        this.config.ondrawngroup(groupDom);
        this.groups.push(group)
        
        this.groupDoms.push(groupDom)
        return groupDom

    }
    addLink(linkData){
        if(!linkData.id) linkData.id = uuidv1();
        let linkDom = this._drawLine(linkData);
        this.config.onlinkconnected(linkDom,linkData);
        this.links.push(linkData);
        this.linkDoms.push(linkDom);
        // linkDom.remove();
        // this.el.select("[f-type='group']").before(linkDom)
        return linkDom;
    }
    reRenderLinks(links){
        this.linkDoms.forEach(v=>v.remove())
        this.links = [];
        links.forEach(this.addLink,this)
    }
    _mergeConfig(config) {
        let defaultConfig = {
            groupRender: "default",
            connectionRender:"default",
            gridSize:30,
            zoom:false,
            onlinkconnecting:function(el){},
            onlinkconnected:function(el){},
            ondrawngroup:function(el){},
            connectionConfig:{},
            groupConfig:{}
        }
        return _.extend({}, defaultConfig, config)
    }
    _renderGroup(group, index) {
        if (!group.id) group.id = uuidv1();
        let g = this.groupRenderers.renderGroup(this.el, group, index,this);
        let position = group.position || [0,0]
        g.attr({
            transform: `translate(${position[0]},${position[1]})`,
            "g-name": group.name,
            "g-id": group.id,
            "f-type":"group",
        }).drag(
            (dx, dy, x, y, e) => {e.stopPropagation(); this._handleOnMove(dx, dy, x, y, e, g) },
            (x, y, e) => { e.stopPropagation();this._handleOnStart(x, y, e, g) },
            (e) => {e.stopPropagation(); this._handleOnEnd(e, g) }
        ).addClass("hover-move")
        return g
    }
    _renderNode(node, index,group) {
        if (!node.id) node.id = uuidv1();
        let g = this.groupRenderers.renderNode(this.el, node, index,this);
        g.attr({
            "g-id":group.id,
            "n-id":node.id,
            "f-type":"node"
        })
        return g;
    }
    _renderPort(port, portIndex, node, nodeIndex, group) {
   
        if (!port.id) port.id = uuidv1();
        let dom = this.groupRenderers.renderPort(this.el, port, portIndex, node, nodeIndex, group);
        dom.attr({
            joint: true,
            "n-port": port.direction,
            "g-name": group.name,
            "n-id": node.id,
            "g-id": group.id,
            "p-id":port.id,
            "f-type":"port"
        })
        return dom;
    }
    _handleOnStart(x, y, e, ctx) {
        
       
        let localMatrix = ctx.transform().localMatrix;
        this.startx = localMatrix.e;
        this.starty = localMatrix.f;
        if (e.target.hasAttribute("joint")) {
            let targetX = localMatrix.e;
            let targetY = localMatrix.f;
            this.status = 0;
            //line 的坐标相对于svg 而不是g，因此加上g的位移
            this.lineStartx = parseFloat(e.target.getAttribute("cx")) + parseFloat(targetX);
            this.lineStarty = parseFloat(e.target.getAttribute("cy")) + parseFloat(targetY);
            //拖曳开始起点为圆点，则新建连线
            let groupId = e.target.getAttribute("g-id");
            let nodeId = e.target.getAttribute("n-id");
            let portId = e.target.getAttribute("p-id");
            let port = e.target.getAttribute("n-port");
            this.tempLink = {
                id: uuidv1(),
                type:"guide",
                source: {
                    groupId,
                    nodeId,
                    portId,
                    port
                }
            }
            

        } else {
            this.status = 1;
        }


    }
    _handleOnMove(dx, dy, x, y, e, ctx) {
        
        let globalMatrix = ctx.transform().globalMatrix;
        let localMatrix = ctx.transform().localMatrix;
        let scale = globalMatrix.a;
        
        if (this.status == 0) {
            //转画线
            // var xSnap = Snap.snapTo(this.config.gridSize, this.lineStartx + dx, 1000000);
            // var ySnap = Snap.snapTo(this.config.gridSize, this.lineStarty + dy, 1000000);
            // if (this.lineEndx == xSnap && this.lineEndy == ySnap) return;

            this.lineEndx = this.lineStartx + dx
            this.lineEndy = this.lineStarty + dy

            this._drawTempLine(this.lineEndx, this.lineEndy)
        } else {
           
            //移动group 因为scale存在 鼠标移动距离 需转成px单位
            var xSnap = Snap.snapTo(this.config.gridSize*scale,  this.startx+dx/scale, 1000000);
            var ySnap = Snap.snapTo(this.config.gridSize*scale,  this.starty+dy/scale, 1000000);
            // let xSnap = this.startx+deltaXSnap/scale;
            // let ySnap = this.starty+deltaYSnap/scale
            
            let xNow = localMatrix.e;
            let yNow =localMatrix.f;
            
            if (xNow == xSnap && yNow == ySnap) return;
           
            ctx.attr({ transform: `translate(${xSnap},${ySnap})` })
            //获取 group id
            let groupId = ctx.node.getAttribute("g-id");
            let groupData = this.groups.find(v=>v.id == groupId)
            groupData.position = [xSnap,ySnap]

            this.lineFollowing(ctx);
        }

    }
    _handleOnEnd(e, ctx) {
        if (this.status == 0) {
            this._drawLineEnd(e);
        } else {
            this._dragTableEnd(e);
        }
    }
    _dragTableEnd(e) {

    }
    _drawLineEnd(e) {
        // 判断落点是否在port 上
        if (!e.target.hasAttribute("joint")) return this.tempLinkEnt.clear();
        // 判断是否连接了自身，连接无效
        let tId = e.target.getAttribute("g-id");
        if (tId == this.tempLink.source.groupId) return this.tempLinkEnt.clear();

        // 连接有效
        let groupId = e.target.getAttribute("g-id");
        let nodeId = e.target.getAttribute("n-id");
        let portId = e.target.getAttribute("p-id");
        let port = e.target.getAttribute("n-port");

        this.tempLink.target = {
            groupId,
            nodeId,
            portId,
            port
        }
        this.tempLink.type = "link";
        let linkData = _.cloneDeep(this.tempLink)
        this.addLink(linkData)
       
    }
    _drawTempLine(x, y) {
        this.tempLink.target = {
            position:[x,y],
        }

        this.tempLinkEnt = this._drawLine(this.tempLink)

    }
    _drawLine(linkData) {
        let g=this.connectionRenderers.drawLine(this.el,linkData,this);
        this.config.onlinkconnecting(g,linkData);
        g.attr({"f-type":"link"})
        return g;

    }
    _drawGroup(group){
        let groupDom = this._renderGroup(group);
        //渲染nodes
        let nodes = group.nodes;

        if (!nodes || !(nodes instanceof Array)) return;

        let nodesDoms = nodes.map((node, i) => {
            
            // 渲染ports
            let ports = node.ports;
            if (!ports || !(ports instanceof Array)) return this._renderNode(node, i,group)

            let nodeDom = this._renderNode(node, i,group)
            let portsDoms = ports.map((port, portIndex) => this._renderPort(port, portIndex, node, i, group), this)
            

            nodeDom.append(Snap.set(...portsDoms));

            return nodeDom

        }, this)

        groupDom.append(Snap.set(...nodesDoms));
        return groupDom;
    }
    lineFollowing(group) {

        let groupId = group.node.getAttribute("g-id");
        let connections = this.links.filter(v => v.source.groupId == groupId || v.target.groupId == groupId);
        connections.forEach(v => this._drawLine(v));

    }

}

export default MainRender


// WEBPACK FOOTER //
// ./src/assets/tflow/mainrender.js